import React from 'react';
import Head from 'next/head';

export default function SEO({ title, description, image, keywords, relUrl, domain }) {
  return (
    <Head>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {/* Facebook Tags */}
      <meta property="og:url" content={`https://${domain}${relUrl}`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="tbrantleyii" />
      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@thecompanydream" />
      <meta name="twitter:creator" content="@thecompanydream" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:domain" content={`https://${domain}`} />
      <meta name="twitter:url" content={`https://${domain}${relUrl}`} />
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="canonical" href={`https://${process.env.NEXT_PUBLIC_DOMAIN}${relUrl}`} />

      {/* Favicon */}
      <link rel="icon" type="image/webp" href="/favicon.webp" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" href="/favicon.ico" />
    </Head>
  );
}
